<template>
  <div>
    <content-area :items="items" />
    <template v-if="info">
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
        >
          <ntp-info :id="`title-${npmItem.testId}`" :ntp-info="npmItem" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
import NtpInfo from './NtpInfo'
export default {
  components: {
    ContentArea,
    NtpInfo
  },
  computed: {
    info () {
      return this.$store.getters['hsm/GET_INFO']
    },
    getBound: function () {
      const information = this.info.interfaces.filter(
        item => item.name === 'bond'
      )

      let ans = this.$t('not_defined')

      if (information && information.length > 0 && information[0].ip !== '0.0.0.0' && information[0].ip !== '255.255.255.255') {
        let mode = ''

        switch (information[0].dgw) {
          case 1:
            mode = 'hot standy'
            break
          case 2:
            mode = 'balance'
            break
          case 3:
            mode = 'aggregation'
            break
          default:
            mode = this.$t('not_defined')
            break
        }

        const netmask2CIDR = information[0].mask
          .split('.')
          .map(Number)
          .map(part => (part >>> 0).toString(2))
          .join('')
        ans = `${information[0].ip}/${netmask2CIDR.split('1').length - 1} - ${mode}`
      }
      return ans
    },
    isBondActive: function () {
      const information = this.info.interfaces.filter(
        item => item.name === 'bond'
      )
      return information[0].ip !== '0.0.0.0' && information[0].ip !== '255.255.255.255'
    },
    getDefaultGateway: function () {
      const information = this.info.interfaces.filter(
        item => item.name === 'default gateway'
      )
      let ans = ''
      if (information && information.length > 0) {
        ans = `${information[0].ip}`
      }
      return ans
    },
    ntpEnabled: function () {
      return this.info.ntp_enabled ? this.$t('enabled') : this.$t('disabled')
    },
    filter_info: function () {
      return this.info.filter.enabled ? this.$t('enabled') : this.$t('disabled')
    },
    npmItem () {
      return {
        title: `${this.$tc('ntp')} (${this.ntpEnabled})`,
        data: this.info.ntp_srv_info,
        testId: 'ntp'
      }
    },
    items () {
      const info = this.info

      if (info.filter.filters.length > 0) {
        info.filter.filters = info.filter.filters.map(ip => `${ip.usr}@${ip.addr}`)
      }

      if (info) {
        const fields = [
          {
            title: this.$t('interface', [1]),
            data: this.getInterface('nic1'),
            html: true,
            testId: 'interface1'
          },
          {
            title: 'DNS 1',
            data: info.dns1 ? info.dns1 : this.$tc('none', 2),
            testId: 'dns1'
          },
          {
            title: 'DNS 2',
            data: info.dns2 ? info.dns2 : this.$tc('none', 2),
            testId: 'dns2'
          },
          {
            title: this.$tc('now'),
            data: `${this.$getDateString({ date: info.current_dt_info })}`,
            testId: 'now'
          },
          {
            title: this.$tc('bond'),
            data: this.getBound,
            testId: 'bond'
          },
          {
            title: this.$tc('gateway'),
            data: this.getDefaultGateway,
            testId: 'gateway'
          },
          {
            title: this.$tc('contact'),
            data: info.snmp.sys_contact ? info.snmp.sys_contact : this.$tc('none', 2),
            testId: 'contact'
          },
          {
            title: this.$tc('location'),
            data: info.snmp.sys_location ? info.snmp.sys_location : this.$tc('none', 2),
            testId: 'location'
          },
          {
            title: this.$tc('trap_community_name'),
            data: info.snmp.community,
            testId: 'name'
          },
          {
            title: this.$tc('routes'),
            data: info.routes.length > 0 ? info.routes : this.$tc('none', 2),
            testId: 'trap'
          },
          {
            title: this.$tc('trap'),
            data: info.snmp.targets.length > 0 ? info.snmp.targets : this.$tc('none', 2),
            testId: 'trap'
          },
          {
            title: this.$tc('syslog'),
            data: info.syslog.length > 0 ? info.syslog : this.$tc('none', 2),
            table: true,
            testId: 'syslog'
          },
          {
            title: `${this.$tc('filter')} (${this.filter_info})`,
            data: info.filter.filters.length > 0 ? info.filter.filters : this.$tc('none', 2),
            table: true,
            testId: 'filter'
          }
        ]
        if (info.model !== 'DMP') {
          const netInterface2 = {
            title: this.$t('interface', [2]),
            data: this.getInterface('nic2'),
            html: true,
            testId: 'interface2'
          }
          fields.splice(1, 0, netInterface2)
        }
        return fields
      }
      return []
    }
  },
  methods: {
    getInterface (name) {
      const information = this.info.interfaces.filter(item => item.name === name)
      let ans = ''

      if (information && information.length > 0) {
        const netmask2CIDR = information[0].mask
          .split('.')
          .map(Number)
          .map(part => (part >>> 0).toString(2))
          .join('')
        ans = this.isBondActive ? 'Slave' : `${information[0].ip}/${netmask2CIDR.split('1').length - 1}`
        ans += ` - ${information[0].up ? information[0].speed : 0} Mb/s - ${information[0].mac} - `
        if (information[0].up) {
          ans += '<span class="green--text">Link UP</span>'
        } else {
          ans += '<span class="red--text">Link DOWN</span>'
        }
      }
      return ans
    },
    format_filter (item) {
      let ans = ''
      if ('usr' in item) {
        ans += item.usr + '@' + item.addr
      } else {
        ans = item.addr
      }

      return ans
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
